<script>
import {
  getTextVariant,
  getVariant,
  getColorVariant,
} from "../../helpers/badgeLookupTable";

export default {
  components: {},
  props: {
    value: {
      type: Number,
      required: false,
    },
    estado: {
      type: String,
      required: false,
    },
  },
  methods: {
    getVariant(status) {
      return getVariant(status);
    },
    getTextVariant(status) {
      return getTextVariant(status);
    },
    getColorVariant(status) {
      return getColorVariant(status);
    },
  },
};
</script>

<template>
  <div
    class="flex flex-row w-full gap-4 shadow-md p-4 rounded-xl cursor-pointer justify-between"
  >
    <div class="flex flex-col gap-2 text-left w-full">
      <div class="font-semibold text-xl">
        {{ estado }}
      </div>
      <div class="relative">
        <div
          class="flex flex-row items-center w-[250px] h-8 rounded-md"
          :style="{ backgroundColor: getColorVariant(estado), opacity: '0.25' }"
        ></div>
        <span :class="[getTextVariant(estado), 'absolute left-2 top-1']"
          >Cantidad de
          <span class="lowercase">despachos {{ estado }}s</span></span
        >
      </div>
    </div>
    <div class="flex flex-row items-center">
      <span class="!text-xl w-full !font-bold" :class="[getTextVariant(estado)]"
        >{{ value ?? "-" }}%</span
      >
    </div>
  </div>
</template>
